'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = { flex: true, 'inline-flex': true };

function flex(property, value) {
  if (property === 'display' && values[value]) {
    return {
      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
    };
  }
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ../~/inline-style-prefixer/lib/static/plugins/flex.js
 ** module id = 720
 ** module chunks = 2
 **/